// extracted by mini-css-extract-plugin
export default {"queueItem":"QueItem_queueItem__ebqjO","button":"QueItem_button__mTFEQ"};